module.exports = __webpack_public_path__ + "static/media/medium_rise.92d55932.svg";